import Footer from './Components/Footer/Footer';
import './App.css';
import state from './state';
import Header from './Components/Header/Header';
import Picture from './Components/Picture/Picture';
import Subtitle from './Components/Subtitle/Subtitle';
import Video from './Components/Video/Video';
import { CustomSlider } from './Components/CustomSlider/CustomSlider';
import Card from './Components/Card/Card';


function App() {
  return (
    <div className="App">
      <Header />
      <Subtitle text={state.Subtitle[0].text}/>
      <CustomSlider src={state.Sliders[0]} />
      <Card  card={state.Cards[0]}/>
      <Video />
      <Subtitle text={state.Subtitle[1].text}/>
      <CustomSlider src={state.Sliders[1]} />
      <Card card={state.Cards[1]}/>
      <Picture />
      <Footer />
    </div>
  );
}


export default App;
